import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import SpanishFile from '../locales/es.json'

// Keeps <html lang> in sync with the active language so browser translation tools and
// screen readers know the page language. Registered before init() so the first
// language detection is not missed.
const applyHtmlLang = () => {
  const lng = i18n.resolvedLanguage || i18n.language || 'es';
  document.documentElement.lang = lng.split('-')[0];
};

i18n.on('initialized', applyHtmlLang);
i18n.on('languageChanged', applyHtmlLang);

i18n
  .use(LanguageDetector) // Detects browser language
  .use(initReactI18next) // Passes i18n to React
  .init({
    supportedLngs: ['es'],
    fallbackLng: 'es',
    defaultLocale: 'es',
    debug: true,
    interpolation: {
      escapeValue: false, // React already protects from XSS
    },
    resources: {
      es: {
        translation: SpanishFile,
      }
    },
  });

export default i18n;